// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__33ExG","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1Q9-s"};